module.exports = __webpack_public_path__ + "img/Brands_5.fb6dbcb1.png";